export const States = ['New South Wales', 'Victoria', 'Queensland', 'Australian Capital Territory', 'South Australia', 'Northern Territory', 'Western Australia'].sort((a, b) => a - b)
export const USERNAME_COOKIE_NAME = 'last_used_username';
export const REMEMBER_USERNAME_COOKIE_NAME = 'remember_username';
export const LAST_USED_PROVIDER_COOKIE_NAME = 'last_used_provider';